import { render, staticRenderFns } from "./MixItemFeedLite.vue?vue&type=template&id=f9867fd6&scoped=true&"
import script from "./MixItemFeedLite.vue?vue&type=script&lang=js&"
export * from "./MixItemFeedLite.vue?vue&type=script&lang=js&"
import style0 from "./MixItemFeedLite.vue?vue&type=style&index=0&id=f9867fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9867fd6",
  null
  
)

export default component.exports